// extracted by mini-css-extract-plugin
export default {"container":"packageDescription_container__GzrYA","description":"packageDescription_description__76BlE","bannerImage":"packageDescription_bannerImage__h0AYU"};